import './style.scss'
import { Slider } from '../../../js/components/Slider/Slider'

export default !function () {
  const block = document.querySelector('.universal-gallery-desc-v2')

  if (!block) {
    return
  }

  const sliderContainer = block.querySelector('.universal-gallery-desc-v2__slider')
  const slides = sliderContainer.querySelectorAll('.universal-gallery-desc-v2__item')
  const controls = sliderContainer.querySelector('.universal-gallery-desc-v2__controls')
  const isInit = slides.length > 1

  const options = {
    wrapper: sliderContainer,
    settings: {
      spaceBetween: 8,
      effect: 'slide',
      loop: false,

      slideClass: 'universal-gallery-desc-v2__item',
      wrapperClass: 'universal-gallery-desc-v2__list',

      pagination: {
        el: '.js-slider-count',
        type: 'fraction',
      },

      navigation: {
        nextEl: '.button-arrow--next',
        prevEl: '.button-arrow--prev'
      },

      media: {
        xl: {
          loop: true,
          effect: 'fade',
          autoHeight: true
        }
      },

      breakpoints: {
        1280: {
          spaceBetween: 0,
          loop: true
        }
      },
    },
    modules: ['pagination', 'navigation', 'effectFade'],
    initCondition: {
      sm: isInit,
      md: isInit,
      lg: isInit,
      xl: isInit
    },
    controls
  }

  new Slider(options).init()
}()

